export var VehicleTypeCategoryEnum;
(function (VehicleTypeCategoryEnum) {
    VehicleTypeCategoryEnum["ARTICULATED_DMP_TRUK"] = "ARTICULATED_DMP_TRUK";
    VehicleTypeCategoryEnum["BACKHOE"] = "BACKHOE";
    VehicleTypeCategoryEnum["CAR"] = "CAR";
    VehicleTypeCategoryEnum["COMPACTOR"] = "COMPACTOR";
    VehicleTypeCategoryEnum["CONCRETE_TRUCK"] = "CONCRETE_TRUCK";
    VehicleTypeCategoryEnum["CRANE_TRUCK"] = "CRANE_TRUCK";
    VehicleTypeCategoryEnum["DOZER"] = "DOZER";
    VehicleTypeCategoryEnum["EXCAVATOR"] = "EXCAVATOR";
    VehicleTypeCategoryEnum["GRADER"] = "GRADER";
    VehicleTypeCategoryEnum["LOADER"] = "LOADER";
    VehicleTypeCategoryEnum["MOTORCYCLE"] = "MOTORCYCLE";
    VehicleTypeCategoryEnum["PANTEC"] = "PANTEC";
    VehicleTypeCategoryEnum["PRIME_MOVER"] = "PRIME_MOVER";
    VehicleTypeCategoryEnum["SCRAPER"] = "SCRAPER";
    VehicleTypeCategoryEnum["SEMI_TRAILER"] = "SEMI_TRAILER";
    VehicleTypeCategoryEnum["SKID_STEER"] = "SKID_STEER";
    VehicleTypeCategoryEnum["STREET_SWEEPER"] = "STREET_SWEEPER";
    VehicleTypeCategoryEnum["TAUTLINER"] = "TAUTLINER";
    VehicleTypeCategoryEnum["TIPPER"] = "TIPPER";
    VehicleTypeCategoryEnum["TRAY"] = "TRAY";
    VehicleTypeCategoryEnum["UTE"] = "UTE";
    VehicleTypeCategoryEnum["VAN"] = "VAN";
    VehicleTypeCategoryEnum["WATER_CART"] = "WATER_CART";
})(VehicleTypeCategoryEnum || (VehicleTypeCategoryEnum = {}));
